 /*
  initialize the pubads service

  With initial load disabled, calls to display() will only register the ad slot.
  No ad content will be loaded until .refresh is called on the slot.
  THIS IS LEGALLY IMPORTANT because we need cookie consent from users before
  we show any ads. See the cookie consent module for the place we actually do this.

  We set collapseDiv: 'DISABLED' so unfilled slots keep their reserved space,
  collapsing them shifts the content below (CLS)
  */
export const setupAndEnablePubAdsService = () => {
  window.googletag.cmd.push(() => {
    window.googletag.setConfig({
      disableInitialLoad: true,
      singleRequest: true,
      collapseDiv: 'DISABLED',
      lazyLoad: {
        fetchMarginPercent: 20,
        renderMarginPercent: 10,
        mobileScaling: 2.0,
      },
    })
    window.googletag.enableServices(); //Remember, this will not *display* ads, only get ready to after consent
  });
};
